import React, { useRef, useEffect } from "react";
import * as d3 from "d3";

const width = 800;
const height = 500;

function D3MapWindow({ geojson }) {
  const ref = useRef();

  useEffect(() => {
    if (!geojson) return;
    const svg = d3.select(ref.current);
    svg.selectAll("*").remove(); // Clear previous

    // Set up projection and path generator
    const projection = d3.geoMercator()
      .fitSize([width, height], geojson);
    const path = d3.geoPath().projection(projection);

    // Draw features
    svg.selectAll("path")
      .data(geojson.features)
      .enter()
      .append("path")
      .attr("d", path)
      .attr("fill", "#69b3a2")
      .attr("stroke", "#222")
      .attr("stroke-width", 1);
  }, [geojson]);

  return (
    <svg ref={ref} width={width} height={height} style={{ background: "#f8f8f8", borderRadius: 8, boxShadow: "0 2px 8px #0002" }}>
      {/* D3 will render here */}
    </svg>
  );
}

export default D3MapWindow;
